<!-- src/app/chatbot/chatbot.component.html -->

@if (isChatVisible) {
  <div
    id="chatbotOverlay"
    class="chatbot-overlay"
    [appDraggable]="!isMinimized ? '.chatbot-header' : '.chatbot-header'"
    [constrainToViewport]="true"
    [style.top]="top"
    [style.left]="left"
    [style.bottom]="bottom"
    [style.right]="right"

    (positionChanged)="onPositionChanged($event)"
  >
    <div class="chatbot-container modal-content" [class.minimized]="isMinimized">

      <!-- Chatbot Header -->
      <div
        class="chatbot-header"
        tabindex="0"
        (keyup.enter)="toggleChat()"
        role="button"
        [attr.aria-pressed]="isChatVisible"
      >
        <!-- Conditional Rendering: Title or Icon based on minimized state -->
        @if (!isMinimized) {
          <i class="fas fa-robot chatbot-icon" aria-label="AI Assistant"></i>
          <span class="chatbot-title">AI Assistant</span>
        } @else {
          <i class="fas fa-comments chatbot-icon" aria-label="Chatbot" (dblclick)="toggleChat()" title="Double-click to open chat"></i>
        }
        @if (!isMinimized) {
          <button
            class="close-button me-4 "
            (click)="toggleChat(); $event.stopPropagation();"
            aria-label="Close chat"
          > _
          </button>
        }
        @if (isChatVisible) {
          <button
            class="close-button me-2"
            (click)="closeChat(); $event.stopPropagation();"
            aria-label="Close chat"
          >
            X
          </button>
        }
      </div>

      <!-- Chatbot Body -->
      @if (!isMinimized) {
        <div class="chatbot-body">

          <!-- Messages Area -->
          <div class="messages" id="messageContainer">
            @if (user == null) {
              <div class="message">
                <div class="message-avatar" >
                  <i class="fas fa-robot bot-icon" aria-label="Bot"></i>
                </div>
                <div class="message-content">
                  <p class="formatted-text">{{'app.chat.intro-anonymous' | translate}}</p>
                </div>
              </div>
            }
            <div class="message">
              <div class="message-avatar">
                <i class="fas fa-robot bot-icon" aria-label="Bot"></i>
              </div>
              <div class="message-content">
                <p class="formatted-text">{{'app.chat.welcome-message' | translate}}</p>
              </div>
            </div>
            @for (msg of messages; track msg) {
              <div
                class="message"
                [class.bot]="msg.sender === 'bot'"
                [class.user]="msg.sender === 'user'"
              >
                <div class="message-avatar">
                  <!-- Conditional Avatar Icon -->
                  @if (msg.sender === 'bot') {
                    <!-- Bot Icon -->
                    <i class="fas fa-robot bot-icon" aria-label="Bot"></i>
                  } @else {
                    <!-- User Icon -->
                    <i class="fas fa-user user-icon" aria-label="User"></i>
                  }
                </div>
                <div class="message-content" aria-live="polite">
                  @switch (msg.type) {
                    @case ('text') {
                      <p [innerHTML]="msg.message | textFormat" class="formatted-text"></p>
                    }
                    @case ('image') {
                      <img [src]="msg.message" alt="Image from chatbot" />
                    }
                    @case ('link') {
                      <a [href]="msg.message" target="_blank">{{ msg.message }}</a>
                    }
                    @case ('error') {
                      <p>{{ msg.message }} {{ msg.error }} class="formatted-text"</p>
                    }
                  }
                  <span class="message-timestamp">{{formatMessageDate(msg)}}</span>
                </div>
              </div>
            }
            @if (isTyping) {
              <!-- Bot Icon -->
              <i class="fas fa-robot bot-icon" aria-label="Bot"></i>
              <!-- Typing Indicator -->
              <div class="typing-indicator" aria-label="Bot is typing">
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
              </div>
            }

          </div>

          <!-- Chatbot Input -->
          <div class="chatbot-input">
        <textarea
          #chatInput
          [(ngModel)]="userInput"
          placeholder="Type your message..."
          (input)="autoResize($event)"
          (keyup.enter)="sendMessage()"
          class="form-control"
          aria-label="Chat message input"
          rows="2"
        ></textarea>
            <button class="send-button" (click)="sendMessage()" aria-label="Send message">
              <i class="fas fa-paper-plane" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      }
    </div>
  </div>
}

